/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/no-unknown-property */
import React from 'react'

import InputLabel from './input-label'

interface Props {
  'aria-label'?: any
  badge?: any
  badgecount?: any
  changeRadio?: any
  checked?: any
  className?: any
  disabled?: any
  formClassName?: any
  icon?: any
  id?: any
  info?: any
  infoClassName?: any
  infoIcon?: any
  inline?: any
  inputProps?: any
  isInfo?: any
  isMandatory?: any
  label?: any
  name?: any
  onChange?: any
  props?: any
  style?: any
  'tip-data'?: any
  tooltip?: any
  type?: any
}

const InputCheckbox = (inputProps: Props) => {
  const changefun = (e: any) => {
    if (inputProps?.type === 'Radio') {
      inputProps?.changeRadio(e, inputProps?.inputProps.changeID)
    }
  }
  return (
    <div className={inputProps?.formClassName}>
      {inputProps?.label && (
        <InputLabel
          badge={inputProps?.badge}
          className={inputProps?.className}
          infoLabel={inputProps?.info}
          isbadge={inputProps?.badgecount}
          isinfoClassName={inputProps?.infoClassName}
          isinfoIcon={inputProps?.infoIcon}
          isinfoLabel={inputProps?.isInfo}
          label={inputProps?.label}
          labelProps={{ htmlFor: inputProps?.id }}
          mandatory={inputProps?.isMandatory}
        />
      )}
      <input
        aria-label={
          inputProps?.inputProps['aria-label'] || inputProps?.inputProps.label
        }
        aria-required={inputProps?.inputProps.isMandatory}
        checked={inputProps?.inputProps?.checked}
        className={inputProps?.className}
        disabled={inputProps?.inputProps.disabled}
        id={inputProps?.inputProps.id}
        name={inputProps?.inputProps.name}
        onChange={inputProps?.onChange}
        onClick={inputProps?.onClick}
        placeholder={inputProps?.inputProps.placeholder}
        readOnly={inputProps?.inputProps.readonly}
        size={inputProps?.inputProps.size || 'sm'}
        style={inputProps.style}
        type={inputProps?.inputProps.type || 'check'}
        value={inputProps?.inputProps.value}
      />
      {inputProps?.inputProps.label && (
        <InputLabel
          badge={inputProps?.inputProps?.badge}
          className={inputProps?.inputProps.className}
          infoLabel={inputProps?.inputProps.info}
          isbadge={inputProps?.inputProps?.badgecount}
          isinfoClassName={inputProps?.inputProps.tooltip}
          isinfoIcon={inputProps?.inputProps.infoIcon}
          isinfoLabel={inputProps?.inputProps.isInfo}
          label={inputProps?.inputProps.label}
          labelProps={{ htmlFor: inputProps?.inputProps.id }}
          mandatory={inputProps?.inputProps.isMandatory}
        />
      )}
      {inputProps?.inputProps?.mandatory && (
        <span className='mandatory'>*</span>
      )}{' '}
      {inputProps?.inputProps?.isInfo && (
        <span tip-data={inputProps?.inputProps?.info}>
          {inputProps?.icon && <span className={inputProps?.icon}></span>}
        </span>
      )}
    </div>
  )
}
export default InputCheckbox
